export default __webpack_public_path__ + "static/media/logo.05f7c097ac8600554742d9c6109ea6c7.svg";